export default __webpack_public_path__ + "static/media/team87.f0fecf53.JPG";